import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, setReport, getStandaloneReport } from "./actions";
import { Card, CardContent, Button, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";
import PrintIcon from "@material-ui/icons/Print";
import { gridStyle, cellStyle } from "../gridHelper";

import "../imgDiv.css";
import styled from "styled-components";
import { StyledHeader } from "../../styles";
import moment from "moment";

const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;

let checkedit = "";
class JcDailyWorksheet extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        checkedit = path[1];
        this.state = {
            reportRetrieved: false,
            edit:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                        ? false
                        : true,
            report: [],
            job_id: !isNaN(Number(path[3])) ? path[3] : false,
        };
        if (props.match.params.subject_name === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({
                report: this.props.report,
            });
        }
    }
    renderItem = (key, detail) => {
        if (this.state.edit === false) {
            return detail ? detail : "N/A";
        } else if (this.state.edit === true && this.state.report !== []) {
            return (
                <input
                    type="text"
                    style={{ paddingLeft: "10px", width: "60%" }}
                    onChange={(event) => {
                        const report = { ...this.state.report };
                        report[key] = event.target.value;
                        this.setState({ report });
                    }}
                    value={this.state.report[key]}
                />
            );
        } else {
            return <Typography variant="body1" />;
        }
    };

    renderSigs(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.signature_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const gstyle = gridStyle;
        const cstyle = cellStyle;
        const render = this.renderItem;
        let color = this.props.color;

        let travellingToSiteEnd = moment(report.travel_to_site_end,'hh:mm:ss a') 
                
        let travellingToSiteStart = moment(report.travel_to_site_start,'hh:mm:ss a');

        let workingOnSiteEnd = moment(report.working_on_site_end,'hh:mm:ss a') 
        let workingOnSiteStart = moment(report.working_on_site_start,'hh:mm:ss a');

        let disposalEnd = moment(report.disposal_time_end,'hh:mm:ss a') 
        let disposalStart = moment(report.disposal_time_start,'hh:mm:ss a');

        let travelToBaseEnd = moment(report.travel_to_base_end,'hh:mm:ss a') 
        let travelToBaseStart = moment(report.travel_to_base_start,'hh:mm:ss a');

        let totalTravellingToSite = travellingToSiteEnd.diff(travellingToSiteStart, 'minutes');
        
        if(totalTravellingToSite < 0 && !isNaN(totalTravellingToSite)){ totalTravellingToSite = -(totalTravellingToSite) } 
        else if(isNaN(totalTravellingToSite)){totalTravellingToSite = 0} 
        
        let totalWorkingOnSite = workingOnSiteEnd.diff(workingOnSiteStart, 'minutes');
        if(totalWorkingOnSite < 0) { totalWorkingOnSite = -(totalWorkingOnSite) }
        else if(isNaN(totalWorkingOnSite)){totalWorkingOnSite = 0} 
        
        let totalDisposalTime = disposalEnd.diff(disposalStart, 'minutes');
        if(totalDisposalTime < 0){ totalDisposalTime = -(totalDisposalTime)}
        else if(isNaN(totalDisposalTime)){totalDisposalTime = 0} 

        let totalTravelToBaseTime = travelToBaseEnd.diff(travelToBaseStart, 'minutes');
        if(totalTravelToBaseTime < 0){ totalTravelToBaseTime = -(totalTravelToBaseTime) }
        else if(isNaN(totalTravelToBaseTime)){totalTravelToBaseTime = 0}
        
        function timeConvert(n) {
            var num = n;
            var hours = (num / 60);
            var rhours = Math.floor(hours);
            var minutes = (hours - rhours) * 60;
            var rminutes = Math.round(minutes);
            return rhours + " hour(s) and " + rminutes + " minute(s).";
        }
        let totalTime = totalTravellingToSite + totalWorkingOnSite + totalDisposalTime + totalTravelToBaseTime;

        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>Daily Worksheet
                    <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                            }}
                            trigger={() => (
                            <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                    }}
                                />
                            )}
                            // copyStyles={true}
                            content={() => this.componentRef}
                        />

                    </Typography>
                </StyledHeader>
                <CardContent>

                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && <this.props.header />}
                            <div
                                className="formContainer"
                                style={gstyle(33, 17, null, color)}
                            >
                                <div style={cstyle(1, 1, 1, 9)}>
                                    <b> Client Name:</b>
                                </div>
                                <div style={cstyle(1, 4, 1, 9, true)}>
                                    {render("client_name", report.client_name)}
                                </div>
                                <div style={cstyle(1, 9, 1, 17)}>Date</div>
                                <div style={cstyle(1, 12, 1, 17, true)}>
                                    {report.timestamp}
                                </div>
                                <div style={cstyle(2, 1, 2, 9)}>
                                    <b> Invoice Address:</b>
                                </div>
                                <div style={cstyle(2, 4, 2, 9, true)}>
                                    {render(
                                        "invoice_address",
                                        report.invoice_address
                                    )}
                                </div>
                                <div style={cstyle(2, 9, 2, 17)}>
                                    <b> Invoiced to:</b>
                                </div>
                                <div style={cstyle(2, 12, 2, 17, true)}>
                                    {render(
                                        "invoice_to",
                                        report.invoice_to
                                    )}
                                </div>
                                <div style={cstyle(3, 1, 3, 9)}>
                                    <b>Client Contact No.</b>
                                </div>
                                <div style={cstyle(3, 4, 3, 9, true)}>
                                    {render(
                                        "client_contact_number",
                                        report.client_contact_number
                                    )}
                                </div>
                                <div style={cstyle(3, 9, 3, 17)}>
                                    <b>URN</b>
                                </div>
                                <div style={cstyle(3, 12, 3, 17, true)}>
                                    {render("urn", report.urn)}
                                </div>
                                <div style={cstyle(4, 1, 4, 17)}>
                                    <b>Site Contact Name</b>
                                </div>
                                <div style={cstyle(4, 6, 4, 9, true)}>
                                    {render(
                                        "site_contact_name",
                                        report.site_contact_name
                                    )}
                                </div>
                                <div style={cstyle(5, 1, 5, 17)}>
                                    <b>Quote No.</b>
                                </div>
                                <div style={cstyle(5, 6, 5, 9, true)}>
                                    {render(
                                        "quote_number",
                                        report.quote_number
                                    )}
                                </div>
                                <div style={cstyle(6, 1, 6, 17)}>
                                    <b>Vehicle:</b>
                                </div>
                                <div style={cstyle(6, 4, 6, 17, true)}>
                                    {render("vehicles", report.vehicles)}
                                </div>
                                <div style={cstyle(7, 1, 7, 17)}>
                                    <b> Operatives:</b>
                                </div>
                                <div style={cstyle(7, 4, 7, 17, true)}>
                                    {render("operatives", report.operatives)}
                                </div>
                                <div style={cstyle(8, 1, 8, 17)}>
                                    <b> Observations & Materials Used:&nbsp;</b>
                                </div>
                                <div style={cstyle(8, 6, 8, 17, true)}>
                                    {render(
                                        "observations_comments",
                                        report.observations_comments
                                    )}
                                </div>
                                <div style={cstyle(9, 1, 9, 17)}>
                                    <b> Site Address:&nbsp;</b>
                                </div>
                                <div style={cstyle(9, 6, 9, 17, true)}>
                                    {render(
                                        "site_address",
                                        report.site_address
                                    )}
                                </div>

                                <div style={cstyle(10, 1, 10, 17, false, true)}>
                                    <b>DETAILS OF Work</b>
                                </div>
                                <div style={cstyle(11, 1, 11, 17)}>
                                    <b>Description Of Work:</b>
                                </div>
                                <div style={cstyle(12, 1, 12, 17, true)}>
                                    {render(
                                        "description_of_works",
                                        report.description_of_works
                                    )}
                                </div>
                                <div style={cstyle(13, 1, 13, 17)}>
                                    <b>Work type:</b>
                                </div>
                                <div style={cstyle(13, 3, 13, 6, true)}>
                                    {render("work_type", report.work_type)}
                                </div>
                                <div style={cstyle(13, 6, 13, 10)}>
                                    <b>Work Amount:</b>
                                </div>
                                <div style={cstyle(13, 8, 13, 13, true)}>
                                    {render("work_amount", report.work_amount)}
                                </div>
                                <div style={cstyle(13, 10, 13, 14)}>
                                    <b>Work Material</b>
                                </div>
                                <div style={cstyle(13, 12, 13, 17, true)}>
                                    {render(
                                        "work_material",
                                        report.work_material
                                    )}
                                </div>
                                <div style={cstyle(14, 1, 14, 17)}>
                                    <b>Work From:</b>
                                </div>
                                <div style={cstyle(14, 3, 14, 17, true)}>
                                    {render("work_from", report.work_from)}
                                </div>
                                <div style={cstyle(14, 8, 14, 17)}>
                                    <b>Work To:</b>
                                </div>
                                <div style={cstyle(14, 9, 14, 17, true)}>
                                    {render("work_to", report.work_to)}
                                </div>
                                <div
                                    style={cstyle(15, 1, 15, 3, false, true)}
                                />
                                <div style={cstyle(15, 3, 15, 6, false, true)}>
                                    <b>Travelling To Site</b>
                                </div>
                                <div style={cstyle(15, 6, 15, 9, false, true)}>
                                    <b> Working On Site</b>
                                </div>
                                <div style={cstyle(15, 9, 15, 13, false, true)}>
                                    <b> Disposal Time/Tipping</b>
                                </div>
                                <div
                                    style={cstyle(15, 13, 15, 17, false, true)}
                                >
                                    <b> Travel To Base</b>
                                </div>
                                
                                <div style={cstyle(16, 1, 16, 3)}>
                                    <b>From</b>
                                </div>
                                <div style={cstyle(16, 3, 16, 6, true)}>
                                    {report.travel_to_site_start}
                                </div>
                                <div style={cstyle(16, 6, 16, 9, true)}>
                                    {report.working_on_site_start}
                                </div>
                                <div style={cstyle(16, 9, 16, 13, true)}>
                                    {report.disposal_time_start}
                                </div>
                                <div style={cstyle(16, 13, 16, 17, true)}>
                                    {report.travel_to_base_start}
                                </div>

                                <div style={cstyle(17, 1, 17, 3)}>
                                <b>  To</b> 
                                </div>
                                <div style={cstyle(17, 3, 17, 6, true)}>
                                    {report.travel_to_site_end}
                                </div>
                                <div style={cstyle(17, 6, 17, 9, true)}>
                                    {report.working_on_site_end}
                                </div>
                                <div style={cstyle(17, 9, 17, 13, true)}>
                                    {report.disposal_time_end}
                                </div>
                                <div style={cstyle(17, 13, 17, 17, true)}>
                                    {report.travel_to_base_end}
                                </div>

                                <div style={cstyle(18, 1, 18, 3)}>
                                   <b> Total Time </b> 
                                </div>
                                <div style={cstyle(18, 3, 18, 6, true)}>
                                    { timeConvert(totalTravellingToSite) }
                                </div>
                                <div style={cstyle(18, 6, 18, 9, true)}>
                                    { timeConvert(totalWorkingOnSite) }
                                </div>
                                <div style={cstyle(18, 9, 18, 13, true)}>
                                    { timeConvert(totalDisposalTime) }
                                </div>
                                <div style={cstyle(18, 13, 18, 17, true)}>
                                    { timeConvert(totalTravelToBaseTime) }
                                </div>
                                <div style={cstyle(19, 1, 19, 3,  true)}>
                                    <b>Total Time</b> : 
                                </div>
                                <div style={cstyle(19, 3, 19, 17,  true)}>
                                     {timeConvert(totalTime)} 
                                </div>


                                <div style={cstyle(20, 1, 20, 17, false, true)}>
                                    <b>DETAILS OF WASTE</b>
                                </div>
                                <div style={cstyle(21, 1, 21, 17)}>
                                    <b>Description Of Waste</b>
                                </div>
                                <div style={cstyle(21, 5, 21, 17, true)}>
                                    {render(
                                        "description_of_waste",
                                        report.description_of_waste
                                    )}
                                </div>




                                <div style={cstyle(22, 1, 22, 17)}>
                                    <b>Quantity Of Waste Disposal</b>
                                </div>
                                <div style={cstyle(22, 5, 22, 17)}>
                                    <b>Kg:</b>
                                </div>
                                <div style={cstyle(22, 6, 22, 9, true)}>
                                    {render("waste_kgs", report.waste_kgs)}
                                </div>
                                <div style={cstyle(22, 9, 22, 10)}>
                                    <b>M3</b>
                                </div>
                                <div style={cstyle(22, 10, 22, 13, true)}>
                                    {render(
                                        "waste_m_squared",
                                        report.waste_m_squared
                                    )}
                                </div>
                                <div style={cstyle(22, 13, 22, 14)}>
                                    <b>Loads</b>
                                </div>
                                <div style={cstyle(21, 14, 21, 17, true)}>
                                    {render(
                                        "waste_load_count",
                                        report.waste_load_count
                                    )}
                                </div>

                                        

                                <div style={cstyle(23, 1, 23, 17)}>
                                    <b>Disposal Site:</b>
                                </div>
                                <div style={cstyle(23, 5, 23, 17, true)}>
                                    {render(
                                        "waste_disposal_site",
                                        report.waste_disposal_site
                                    )}
                                </div>

                                
                                <div style={cstyle(24, 1, 24, 17, false, true)}>
                                    <b>CERTIFICATION OF SATISFACTION</b>
                                </div>


                                <div style={cstyle(24, 1, 24, 17)}>
                                    <b>
                                        I Hereby Certify That This Work Has Been
                                        Carried Out To My Satisfaction
                                    </b>
                                </div>

                            </div>
                            
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(1, 1, 1, 1, false, true)}>
                                    <b>Attached Signatures</b>
                                </div>
                                {report.attached_signatures &&
                                    this.renderSigs(report.attached_signatures)}
                            </div>
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(1, 1, 1, 1, false, true)}>
                                    <b>Attached Photos</b>
                                </div>
                                {report.attached_photos &&
                                    this.renderPhotos(report.attached_photos)}
                            </div>
                        </div>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {(this.state.editing ||
                            checkedit === "report-edit-jobpack") && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    this.state.reportType
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                    </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                    </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {(this.state.editing ||
                            checkedit === "report-edit") && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit",
                                        "report-view-standalone"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    this.state.reportType
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                    </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                    </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            report: selectCurrentReport(store),
        };
    },
    { setActivity, getReport, setReport, getStandaloneReport }
)(JcDailyWorksheet);
